import { useEffect } from 'react';
import { Canvas } from 'fabric';
import { onModelRendered } from '../../canvas/canvas-events';
import { initAllPills } from '../utils/hydrate-pills';

/**
 * Re-attaches pill and pill-group listeners after the model re-renders (undo/redo),
 * where objects are rebuilt from scratch. `initAllPills` is idempotent, so it only
 * wires the freshly rebuilt objects.
 */
export const usePillGroupWiring = (canvas: Canvas | null): void => {
  useEffect(() => {
    if (!canvas) return;
    return onModelRendered(canvas, () => initAllPills(canvas));
  }, [canvas]);
};
